import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsidecharterViewRoutingModule } from './insidecharter-view-routing.module';
import { InsidecharterViewComponent } from './insidecharter-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { AppBackButtonModule } from 'src/app/shared/components/app-back-button/app-back-button.module';

@NgModule({
  declarations: [InsidecharterViewComponent],
  imports: [
    CommonModule,
    InsidecharterViewRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    MatAutocompleteModule,
    MatInputModule,
    PcMultiSelectFilterModule,
    CustomDatePickerModule,
    CustomTimpickerModule,
    CustomInputModule,
    AppBackButtonModule,
  ]
  
})
export class InsidecharterViewModule { }